import { createApp } from "vue";
import "./style.css";
import "./common.css";
import "@gohighlevel/ghl-ui/dist/style.css";
import App from "./App.vue";
import "@platform-ui/highrise/style.css";
import { router } from "./router";
import { createPinia, type Pinia } from "pinia";
import { i18n } from "./plugin/vue-i18n";
import mitt from "mitt";
import "bootstrap/dist/css/bootstrap.min.css";
import { setupSentry } from "./util/setupSentry";

interface PiniaWithStores extends Pinia {
  _s: Map<string, any>;
}

const app = createApp(App);
const emitter = mitt();
app.config.globalProperties.emitter = emitter;
const pinia = createPinia();
app.use(pinia);
app.use(i18n);
app.use(router);
app.mount("#builderApp");
setupSentry(app, router, process.env.NODE_ENV);
window.__HOST_CONTEXT__ = window.__HOST_CONTEXT__ || {};
window.__HOST_CONTEXT__.piniaStores = (pinia as PiniaWithStores)._s;
window.__HOST_CONTEXT__.i18n = i18n;
